import { useEffect, useState } from 'react';

export default function usePreviewReadiness(scopeKey, bootstrapReady, indicatorsReady) {
  const [expiredScope, setExpiredScope] = useState(null);
  useEffect(() => {
    const timer = window.setTimeout(() => setExpiredScope(scopeKey), 10000);
    return () => window.clearTimeout(timer);
  }, [scopeKey]);
  // A slow/unavailable indicator cannot hold previews forever; neither path holds up rendering.
  return bootstrapReady && (indicatorsReady || expiredScope === scopeKey);
}
